/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createStaticCurrencyFromDiscriminatorValue, type StaticCurrency } from '../models';
// @ts-ignore
import { InuseRequestBuilderRequestsMetadata, type InuseRequestBuilder } from './inuse';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /currencies
 */
export interface CurrenciesRequestBuilder extends BaseRequestBuilder<CurrenciesRequestBuilder> {
    /**
     * The inuse property
     */
    get inuse(): InuseRequestBuilder;
    /**
     * Retrieves a list of configured currencies
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<StaticCurrency[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<StaticCurrency[] | undefined>;
    /**
     * Retrieves a list of configured currencies
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CurrenciesRequestBuilderUriTemplate = "{+baseurl}/currencies";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CurrenciesRequestBuilderNavigationMetadata: Record<Exclude<keyof CurrenciesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    inuse: {
        requestsMetadata: InuseRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CurrenciesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CurrenciesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createStaticCurrencyFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
